import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce() {
		try {
			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/mmcCustCodeLists`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/** 교정업체 셀렉트 정보 조회 */
	async getMmcInstList() {
		try {
			const response = await client.get(`${BASE_URL}/mmc/mmcm/mesCal/v1/mmcInsts`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getMesPvoList({ searchParams, pagingInfo }) {
		const queryStr = objectToQueryString({
			mesEqipNo: searchParams.mesEqipNo?.trim(),
			mesEqipNm: searchParams.mesEqipNm?.trim(),
			calStCd: searchParams.calStCd, //교정상태
			calInstCd: searchParams.calInstCd, //교정업체
			runStCd: searchParams.runStCd, //가동상태
			user1Id: searchParams.userId,
			user1Nm: !searchParams.userId ? searchParams.userName?.trim() : '',
			useDeptCd: searchParams.useDeptCd ? searchParams.useDeptCd : searchParams.userDeptNm?.trim(),
			strDt: searchParams.strDt,
			endDt: searchParams.endDt,
			currentPage: pagingInfo.currentPage,
			pageUnit: pagingInfo.pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/mmc/mmcm/mesCalPvo/v1/pvos${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPvoHisList(params, pvoPagingInfo) {
		const queryStr = objectToQueryString({
			strDt: params.strDt,
			endDt: params.endDt,
			currentPage: pvoPagingInfo.currentPage,
			pageUnit: pvoPagingInfo.pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/mmc/mmcm/mesCalPvo/v1/pvos/mesEqipNo/${params.mesEqipNo}${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	// 불출
	async savePvo(data) {
		try {
			const response = await client.post(`${BASE_URL}/mmc/mmcm/mesCalPvo/v1/status/2/pvo`, data);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async fileDownload(params) {
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		try {
			const response = await client.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' });
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
